import { Card, Inline, vars, Text } from '@etg/wings';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cardStyles = css`
  border: 1px solid ${vars.colors.divider};
`;
const iconStyles = css`
  flex: 0 0 auto;
`;
const CheckInBaggageSelfTransferCard = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Card, {
    className: cardStyles,
    "data-testid": "check-in-baggage-self-transfer-card",
    children: /*#__PURE__*/_jsxs(Inline, {
      alignY: "top",
      noWrap: true,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Icon, {
        "aria-hidden": true,
        className: iconStyles,
        color: vars.colors.promotional.foreground,
        id: "self-transfer",
        size: "20px"
      }), /*#__PURE__*/_jsx(Text, {
        children: t('IbeClient.Itinerary.Drawer.BaggageInformation.SelfTransfer.Card.Text')
      })]
    })
  });
};
export default CheckInBaggageSelfTransferCard;
//# sourceMappingURL=CheckInBaggageSelfTransferCard.js.map